// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateVendorRequest
 */
export interface CreateVendorRequest {
    /**
     * 
     * @type {string}
     * @memberof CreateVendorRequest
     */
    contact_email?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorRequest
     */
    contact_name?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorRequest
     */
    notes?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateVendorRequest
     */
    type?: string;
}

/**
 * Check if a given object implements the CreateVendorRequest interface.
 */
export function instanceOfCreateVendorRequest(value: object): value is CreateVendorRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    return true;
}

export function CreateVendorRequestFromJSON(json: any): CreateVendorRequest {
    return CreateVendorRequestFromJSONTyped(json, false);
}

export function CreateVendorRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateVendorRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'contact_email': json['contact_email'] == null ? undefined : json['contact_email'],
        'contact_name': json['contact_name'] == null ? undefined : json['contact_name'],
        'name': json['name'],
        'notes': json['notes'] == null ? undefined : json['notes'],
        'type': json['type'] == null ? undefined : json['type'],
    };
}

export function CreateVendorRequestToJSON(json: any): CreateVendorRequest {
    return CreateVendorRequestToJSONTyped(json, false);
}

export function CreateVendorRequestToJSONTyped(value?: CreateVendorRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'contact_email': value['contact_email'],
        'contact_name': value['contact_name'],
        'name': value['name'],
        'notes': value['notes'],
        'type': value['type'],
    };
}
